var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('bread-crumb',{attrs:{"navigationArray":_vm.navigationLink}}),(_vm.getPage && _vm.getPage.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.getPage.content)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }